import { render, staticRenderFns } from "./LandingBongo.vue?vue&type=template&id=5b9b8ac4&scoped=true&"
import script from "./LandingBongo.vue?vue&type=script&lang=js&"
export * from "./LandingBongo.vue?vue&type=script&lang=js&"
import style0 from "./LandingBongo.vue?vue&type=style&index=0&id=5b9b8ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9b8ac4",
  null
  
)

export default component.exports